import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import Releaser from "../../assets/images/modems/processed/releaser_1.png"

const Releaser_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={Releaser} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.releaser.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.releaser.details.p1')}</li>
          <li>{t('accessoires.releaser.details.p2')}</li>
          <li>{t('accessoires.releaser.details.p3')}</li>
          <li>{t('accessoires.releaser.details.p4')}</li>
          <li>{t('accessoires.releaser.details.p5')}</li>
          <li>{t('accessoires.releaser.details.p6')}</li>
        </ul>
      </div>

    </div>
  );
};

export default Releaser_SPEC;
